export default "__VITE_ASSET__kdIGMcQt__"